import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
  encodeURLParameterValueqlj48e6qtqd4 as encodeURLParameterValue,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UrlDecodedParametersBuilderClass;
function UrlDecodedParametersBuilder() {
  if (UrlDecodedParametersBuilderClass === VOID) {
    class $ {
      constructor(encodedParametersBuilder) {
        this.encodedParametersBuilder_1 = encodedParametersBuilder;
        this.caseInsensitiveName_1 = this.encodedParametersBuilder_1.get_caseInsensitiveName_ehooe5_k$();
      }
      build_1k0s4u_k$() {
        return decodeParameters(this.encodedParametersBuilder_1);
      }
      get_caseInsensitiveName_ehooe5_k$() {
        return this.caseInsensitiveName_1;
      }
      getAll_ffxf4h_k$(name) {
        var tmp0_safe_receiver = this.encodedParametersBuilder_1.getAll_ffxf4h_k$(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
          var _iterator__ex2g4s = tmp0_safe_receiver.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$2 = decodeURLQueryComponent(item, VOID, VOID, true);
            destination.add_utx5q5_k$(tmp$ret$2);
          }
          tmp = destination;
        }
        return tmp;
      }
      contains_zh0gsb_k$(name) {
        return this.encodedParametersBuilder_1.contains_zh0gsb_k$(encodeURLParameter(name));
      }
      names_1q9mbs_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.encodedParametersBuilder_1.names_1q9mbs_k$();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = decodeURLQueryComponent(item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return toSet(destination);
      }
      isEmpty_y1axqb_k$() {
        return this.encodedParametersBuilder_1.isEmpty_y1axqb_k$();
      }
      entries_qbkxv4_k$() {
        return decodeParameters(this.encodedParametersBuilder_1).entries_qbkxv4_k$();
      }
      append_rhug0a_k$(name, value) {
        return this.encodedParametersBuilder_1.append_rhug0a_k$(encodeURLParameter(name), encodeURLParameterValue(value));
      }
      appendAll_k8dlt1_k$(stringValues) {
        return appendAllEncoded(this.encodedParametersBuilder_1, stringValues);
      }
      appendAll_ytnfgb_k$(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(values, 10));
        var _iterator__ex2g4s = values.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = encodeURLParameterValue(item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return this.encodedParametersBuilder_1.appendAll_ytnfgb_k$(tmp, destination);
      }
      clear_j9egeb_k$() {
        return this.encodedParametersBuilder_1.clear_j9egeb_k$();
      }
    }
    initMetadataForClass($, 'UrlDecodedParametersBuilder');
    UrlDecodedParametersBuilderClass = $;
  }
  return UrlDecodedParametersBuilderClass;
}
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.build_1k0s4u_k$();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.names_1q9mbs_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp0_elvis_lhs = parameters.getAll_ffxf4h_k$(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$4 = encodeURLParameterValue(item);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    _this__u8e3s4.appendAll_ytnfgb_k$(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.names_1q9mbs_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp0_elvis_lhs = parameters.getAll_ffxf4h_k$(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$4 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    _this__u8e3s4.appendAll_ytnfgb_k$(tmp, destination);
  }
}
//region block: exports
export {
  UrlDecodedParametersBuilder as UrlDecodedParametersBuilder18hwlye3pykgz,
  encodeParameters as encodeParameters1kx5voquz3xxo,
};
//endregion

//# sourceMappingURL=UrlDecodedParametersBuilder.mjs.map
